import { saveAs } from 'file-saver';

export const download = ({data, headers}: any) => {
  let filename = 'file';

  const contentDisposition = headers['content-disposition'];
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?(?<filename>[^"']*)"?/);
    if (match) {
      filename = match.groups.filename;
    }
  }

  saveAs(new Blob([data], {type: "application/octet-stream"}), filename);
}
